import {useMediaQuery} from "@mui/material";

export const ShowLess1024px = () => {
    return useMediaQuery('(max-width: 1024px)');
}

export const ShowMore375px = () => {
    return useMediaQuery('(min-width: 375px)');
}